import { Invoke } from '@swf/components/StarsWizard/Flow';
import type { FlowConfig } from '@swf/core/types/Wizard';

import RMFAddress from '../components/RMFAddress/RMFAddress';
import RMFDepositLimit from '../components/RMFDepositLimit/RMFDepositLimit';
import RMFLegalName from '../components/RMFLegalName/RMFLegalName';

import useRMFBaseSteps from './useRMFBaseSteps';
import { Service } from './useRmfServices';

const useRmfGRFlow = (): FlowConfig => {
  const {
    forkDobCheck,
    invokeSignupDob,
    jumpToFeatureStep,
    invokeLegalNameSave,
    forkDepositLimits
  } = useRMFBaseSteps();

  const invokeAdressSave = new Invoke(Service.RmfAddressSave, RMFDepositLimit, RMFAddress);

  return [
    RMFLegalName,
    invokeLegalNameSave,
    invokeSignupDob,
    forkDobCheck,
    invokeAdressSave,
    RMFDepositLimit,
    forkDepositLimits,
    jumpToFeatureStep
  ];
};

export default useRmfGRFlow;
